export const ACCOUNTS_URL = process.env.REACT_APP_ACCOUNTS_URL
export const LOGIN_ROUTE = `${ACCOUNTS_URL}/login?appref=https://app.${window.location.hostname}`
export const SIGNUP_ROUTE = `${ACCOUNTS_URL}/signup?appref=https://app.${window.location.hostname}`
